/**
 * Auditor SOFU: hace y carga inspecciones de Seguridad Vial en cualquier espacio de trabajo sin estar vinculado
 * (Inspección de auditoría, /seguridadvial/inspecciones/cargar). Lo da el panel administrativo con el claim
 * `auditor`; los administradores SOFU (`role: admin`) también lo son. El claim llega en el token de la sesión.
 */
import { auth } from "@/firebase";

/**
 * Si la sesión es de un auditor SOFU o de un administrador SOFU.
 * @param {boolean} [actualizar=false] - Pide un token nuevo, para ver un claim que se dio con la sesión abierta.
 * @returns {Promise<boolean>}
 */
export async function esAuditorSofu(actualizar = false) {
  const usuario = auth.currentUser;
  if (!usuario) return false;
  try {
    const { claims } = await usuario.getIdTokenResult(actualizar);
    return claims.auditor === true || claims.role === "admin";
  } catch (error) {
    // Sin conexión no se puede pedir un token nuevo: vale el que ya tiene la sesión
    if (actualizar) return esAuditorSofu(false);
    console.warn("No se pudo leer la sesión para saber si es auditor SOFU:", error);
    return false;
  }
}
